import React from "react";
import "../css/components/name-search-filter.css";

const NameSearchFilter = ({ onChange, placeholder = "Search Name", labelText = "Filter" }) => {
  return (
    <div className="filter-box">
      <div className="filter-container">
        <label className="filter-label">{labelText}</label>
        <input
          type="text"
          className="filter-input"
          placeholder={placeholder}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default NameSearchFilter;